<template>
	<div class="tuwen">
		<ul class="flexDiv">
		  <li v-for="(item,index) in dataList" :key="item.ID" class="wow fadeInLeft imgBox" :data-wow-delay="index/8+'s'">
		    <img :src="item.FileUrl" alt="">
		  </li>
		</ul>
	</div>
</template>

<script>
	export default{
		name:'tuwen',
		props:{
			dataList:{
				type: Array,
				default: () => []
			},
			moreLink: {
			   type: String,
			   default: ''
			}
		}
	}
</script>

<style>
  .tuwen{
    padding: 20px;
  }
  .tuwen ul{
    position: relative;
    flex-wrap: wrap;
  }
  .tuwen ul li{
    margin-bottom: 20px;

  }
  .tuwen ul::after{
    content: '';
    width: 379px;
  }
</style>



// WEBPACK FOOTER //
// src/components/tuwen.vue